// import js shims for IE11 compatibility
import "airbnb-js-shims";
import "reset-css";
import 'url-search-params-polyfill';

import "typeface-roboto";
import Raven from "raven-js";
import React from "react";
import ReactDOM from "react-dom";

// redux
import { compose, createStore, combineReducers, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { Provider } from "react-redux";
import createSagaMiddleware from "redux-saga";
import createHistory from "history/createBrowserHistory";
import rootSaga from "./redux/sagas";
import reducers from "./redux/reducers";
import { reducer as notifications } from "react-notification-system-redux";

// firebase
import {
  reactReduxFirebase,
  firebaseStateReducer,
  getFirebase
} from "react-redux-firebase";
import * as firebase from "firebase";

// routing
import {
  ConnectedRouter,
  routerReducer,
  routerMiddleware
} from "react-router-redux";
import Routes from "./router/routes";

import AppWrapper from "./containers/AppWrapper";

// CSS
// Make sure to import default styles.
// This only needs to be done once; probably during bootstrapping process.
import "react-select/dist/react-select.css";
import "react-virtualized/styles.css";
import "react-virtualized-select/styles.css";
import "react-quill/dist/quill.snow.css";
import "normalize.css";
import "./index.css";

import registerServiceWorker from "./registerServiceWorker";

// Initialize sentry.io raven
Raven.config(
  "https://379cfd3860584c308b860de0ea04c516@sentry.io/226928"
).install();

// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory();

// Build the middleware for intercepting and dispatching navigation actions
const historyMiddleware = routerMiddleware(history);

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// Firebase config
const config = {
  apiKey: "AIzaSyAXgc1L_LXfVXg1eH5Dyei-KL_jkhejPJw",
  authDomain: "jumper-7-62016.firebaseapp.com",
  databaseURL: "https://jumper-7-62016.firebaseio.com",
  projectId: "jumper-7-62016",
  storageBucket: "jumper-7-62016.appspot.com",
  messagingSenderId: "204540625324"
};
const rrfConfig = {
  userProfile: "users",
  customAuthParameters: {
    google: {
      // prompts user to select account on every google login
      prompt: "select_account"
    }
  }
}; // react-redux-firebase config

// initialize firebase instance
firebase.initializeApp(config);
document.body.addEventListener(
  "touchmove",
  function(e) {
    e.preventDefault();
  },
  { passive: false }
);
// Add reduxReduxFirebase to compose
const createStoreWithFirebase = compose(
  reactReduxFirebase(firebase, rrfConfig) // firebase instance as first argument
)(createStore);

// Add the reducer to your store on the `router` key
// Also apply our middleware for navigating
const store = createStoreWithFirebase(
  combineReducers(
    Object.assign({}, reducers, {
      // ...reducers,
      firebase: firebaseStateReducer,
      router: routerReducer,
      notifications
    })
  ),
  composeWithDevTools(applyMiddleware(historyMiddleware, sagaMiddleware))
);

sagaMiddleware.run(rootSaga, getFirebase);

ReactDOM.render(
  <Provider store={store}>
    {/* ConnectedRouter will use the store from Provider automatically */}
    <ConnectedRouter history={history}>
      <AppWrapper>
        <Routes />
      </AppWrapper>
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js